import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/part-pay-icon.svg")